module.exports = __webpack_public_path__ + "static/media/load_repayment.27cb588a.svg";